import { combineReducers } from "redux";
import { reducerModules } from "redux/helpers";

const reducers = combineReducers({
  ...reducerModules,
});

export default reducers;
